import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';

export const whoami = (services: CommandServices) => {
  return createCommand('whoami')
    .description('Display the email of the logged in Wix user')
    .action(async (_, command) => {
      const { getUserInfo } = await import('@wix/cli-auth');
      const { WhoamiCommand } = await import('../components/WhoamiCommand.js');
      const { renderCommand } = await import('./render-command.js');

      const userInfo = await getUserInfo();

      await renderCommand(
        command,
        services,
        <WhoamiCommand userInfo={userInfo} />
      );
    });
};
